import { render, staticRenderFns } from "./ListeningWordsFormV08.vue?vue&type=template&id=31c59240&"
import script from "./ListeningWordsFormV08.vue?vue&type=script&lang=js&"
export * from "./ListeningWordsFormV08.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports